"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
// Constants
var promptTrigger_1 = require("@src/containers/BusinessManager/const/promptTrigger");
// Icons
var DeleteIcon_svg_1 = __importDefault(require("../../icons/DeleteIcon.svg"));
var DeleteIconWrapper = styled_components_1["default"](icon_1["default"])({
    marginTop: 30,
    marginLeft: 11,
    height: 24,
    width: 24,
});
var ValueInputText = styled_components_1["default"](text_2["default"])({
    marginTop: 6,
});
var parseToType = function (variableType, value) {
    if (variableType === promptTrigger_1.SUPPORTED_TYPES.number) {
        return parseInt(value, 10);
    }
    return value;
};
var TriggerRule = function (_a) {
    var variable = _a.variable, operator = _a.operator, value = _a.value, meta = _a.meta, onRemove = _a.onRemove, onChange = _a.onChange, attachTo = _a.attachTo;
    // Renders Variable Selection Dropdown
    var renderVariableSelectionDropdown = function () {
        var variableOptions = Object.keys(promptTrigger_1.SUPPORTED_VARIABLES).map(function (variable) {
            return {
                name: promptTrigger_1.SUPPORTED_VARIABLES[variable].label,
                type: promptTrigger_1.SUPPORTED_VARIABLES[variable].type,
                id: variable,
            };
        });
        var variableValue = variableOptions.filter(function (option) { return option.id === variable; })[0];
        return (react_1["default"].createElement(box_1["default"], { width: "185px", padding: "0px", marginRight: "16px", position: "relative", flexDirection: "column" },
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Trigger Based On"),
            react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, attachTo: attachTo, options: variableOptions, placeholder: "Please select the metric to be used", optionKey: "name", value: variableValue, onChange: function (value) { return onChange('variable', value.id); } })));
    };
    // Renders Condition Selection Dropdown
    var renderOperandSelectionDropdown = function () {
        if (!variable)
            return null;
        var variableType = promptTrigger_1.SUPPORTED_VARIABLES[variable].type;
        var supportedOperators = promptTrigger_1.SUPPORTED_OPERATORS_BY_TYPE[variableType];
        var operatorOptions = supportedOperators.map(function (operator) {
            return {
                name: promptTrigger_1.SUPPORTED_OPERATORS[operator],
                id: operator,
            };
        });
        var operatorValue = operatorOptions.filter(function (option) { return option.id === operator; })[0];
        return (react_1["default"].createElement(box_1["default"], { width: "185px", padding: "0px", marginRight: "16px", flexDirection: "column" },
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Condition"),
            react_1["default"].createElement(dropdown_1["default"], { themed: true, withSearch: true, attachTo: attachTo, options: operatorOptions, placeholder: "Please select the operator to be used", optionKey: "name", value: operatorValue, onChange: function (value) { return onOperatorChanged(value.id); } })));
    };
    // Renders Input Field for Value of Prompt Rules
    var renderValueInputOption = function () {
        if (!variable)
            return null;
        var variableData = promptTrigger_1.SUPPORTED_VARIABLES[variable];
        return (react_1["default"].createElement(box_1["default"], { padding: "0px", width: "357px", flexDirection: "column" },
            !promptTrigger_1.FIXED_VALUE_OPERATORS[operator] && (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Value"),
                react_1["default"].createElement(ValueInputText, { themed: true, min: 0, placeholder: "Value to be used for Comparison", value: String(value || ''), inputType: variableData.type, onChange: function (value) {
                        onChange('value', parseToType(variableData.type, value));
                    } }))),
            variableData.metaKeys.map(function (metaKey) {
                return (react_1["default"].createElement(box_1["default"], { padding: "0px", marginTop: !promptTrigger_1.FIXED_VALUE_OPERATORS[operator] ? '6px' : '0px', flexDirection: "column" },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, metaKey.title),
                    react_1["default"].createElement(ValueInputText, { themed: true, min: 0, placeholder: "Additional meta fields for the rule", value: String(meta[metaKey.key]), inputType: metaKey.type, onChange: function (value) {
                            return onMetaFieldChanged(metaKey.key, parseToType(metaKey.type, value));
                        } })));
            })));
    };
    // On Condition Change Handler
    var onOperatorChanged = function (operatorId) {
        onChange('operator', operatorId);
        if (promptTrigger_1.FIXED_VALUE_OPERATORS[operatorId]) {
            onChange('value', promptTrigger_1.FIXED_VALUE_OPERATORS[operatorId].value);
        }
    };
    // Meta Field Change Handler
    var onMetaFieldChanged = function (metaKey, value) {
        var metaData = __assign({}, meta);
        metaData[metaKey] = value;
        onChange('meta', metaData);
    };
    return (react_1["default"].createElement(box_1["default"], { padding: "0px", marginTop: "16px" },
        renderVariableSelectionDropdown(),
        renderOperandSelectionDropdown(),
        renderValueInputOption(),
        react_1["default"].createElement(DeleteIconWrapper, { src: DeleteIcon_svg_1["default"], onClick: onRemove })));
};
TriggerRule.defaultProps = {
    variable: 'page_url',
    operator: 'eq',
    value: '',
    meta: {},
    onChange: function () { },
    onRemove: function () { },
    attachTo: null,
};
exports["default"] = TriggerRule;
